import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../material/material.module";
import { UsuarioService } from "../../../providers/usuario.service";
import { AccionesPropuestaComponent, DialogAccionesPropuesta, DialogConfirmarPropuesta, DialogConfirmarPropuestaArchivada, SubirArchivosPropuesta } from "./acciones-propuesta.component";
import { PropuestasService } from "../../../providers/propuestas.service";
import { EntidadService } from "../../../providers/entidad.service";
import { ActividadesModule } from "../../actividades/actividades.module";
import { ContactoModule } from "../../../forms/entidad/contactos/contacto.module";
import { CotizacionModule } from "../../../forms/cotizaciones/cotizacion.module";
import { ImageUploadModule } from "../../archivos/image-upload.module";
import { CrearActividadDialogComponent } from './crear-actividad-dialog/crear-actividad-dialog.component';
import { TareaModule } from "../../../forms/tareas/tarea.module";
import { VerIncidenciaComponent } from "../../incidencia/ver-incidencia/ver-incidencia.component";
import { MatChipsModule } from "@angular/material";
import { CrearIncidenciaDialogComponent } from './crear-incidencia-dialog/crear-incidencia-dialog.component';
import { IncidenciaModule } from "../../../forms/incidencias/incidencia.module";
import { CursoService } from "../../../providers/cursos.service";


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ActividadesModule,
        ContactoModule,
        CotizacionModule,
        TareaModule,
        MatChipsModule,
        IncidenciaModule,
        ImageUploadModule.forRoot()
    ],
    declarations: [
        AccionesPropuestaComponent,
        DialogAccionesPropuesta,
        DialogConfirmarPropuesta,
        DialogConfirmarPropuestaArchivada,
        SubirArchivosPropuesta,
        CrearActividadDialogComponent,
        VerIncidenciaComponent,
        CrearIncidenciaDialogComponent,
    ],
    entryComponents: [
        AccionesPropuestaComponent,
        DialogAccionesPropuesta,
        DialogConfirmarPropuesta,
        DialogConfirmarPropuestaArchivada,
        SubirArchivosPropuesta,
        CrearActividadDialogComponent,
        CrearIncidenciaDialogComponent,
        VerIncidenciaComponent,
    ],
    exports: [
        AccionesPropuestaComponent,
        DialogAccionesPropuesta,
        DialogConfirmarPropuesta,
        DialogConfirmarPropuestaArchivada,
        SubirArchivosPropuesta,
    ],
    providers: [
        UsuarioService,
        PropuestasService,
        EntidadService,
        CursoService
    ]
})
export class AccionesPropuestaModule { }
